<div
  #slideContainer
  appWorkSwipeNavigation
  [swipeNavigationEnabled]="isSwipeNavigationEnabled"
  [canSwipePrevious]="canPrevious"
  [canSwipeNext]="canNext"
  [prepareSwipeNavigation]="prepareSwipeNavigation"
  (swipeNavigation)="onSwipeNavigation($event)"
  (swipeNavigationDragStarted)="pinProgressPanelsForSwipe()"
  (swipeNavigationDragSettled)="restorePinnedProgressPanels()"
  [style.--work-details-slide-animation-duration]="slideAnimationDuration"
>
  <ng-content></ng-content>
</div>
@if (shouldDisplaySwipeTip) {
<div
  class="workDetailsSwipeTip fixed inset-0 z-[60] flex flex-col items-center justify-center gap-5 px-6 text-center bg-blackest/80"
  (click)="dismissSwipeTip()"
  (keyup)="onTipKeyUp($event)"
  tabindex="0"
>
  <span
    class="workDetailsSwipeTip__icon block w-[72px] h-[72px] bg-white mask-[url(/assets/images/icons/swipe.svg)] mask-no-repeat mask-center mask-size-[72px_72px]"
  ></span>
  <p
    class="workDetailsSwipeTip__text text-white text-base max-w-[280px] mt-0 whitespace-pre-line [text-shadow:0_1px_3px_rgb(0_0_0_/0.65)]"
  >
    {{ "SWIPE_WORKS_TIP" | translate }}
  </p>
  <button
    type="button"
    class="workDetailsSwipeTip__cta btn px-5 py-2 rounded-full bg-white text-black font-bold"
    (click)="dismissSwipeTip()"
  >
    {{ "SWIPE_WORKS_TIP_CTA" | translate }}
  </button>
</div>
}
